var map = {
	"./404_1.svg": 90,
	"./404_2.svg": 85764,
	"./about.svg": 98061,
	"./add.svg": 59614,
	"./android.svg": 9357,
	"./archive.svg": 59706,
	"./baidu.svg": 65909,
	"./bili.svg": 13829,
	"./bozhu.svg": 49977,
	"./chrome.svg": 88733,
	"./copyright.svg": 67645,
	"./csdn.svg": 53393,
	"./deep.svg": 19143,
	"./dianzan.svg": 34035,
	"./edge.svg": 29753,
	"./email.svg": 51533,
	"./emoji1.svg": 38089,
	"./emoji2.svg": 23934,
	"./friendLink.svg": 5660,
	"./gitee.svg": 35167,
	"./github.svg": 89460,
	"./google.svg": 94512,
	"./guanfang.svg": 86350,
	"./guanzhume.svg": 27633,
	"./home.svg": 49429,
	"./hot.svg": 68399,
	"./hot2.svg": 58211,
	"./link.svg": 14121,
	"./mac.svg": 68926,
	"./message.svg": 30860,
	"./navication.svg": 16909,
	"./note.svg": 12280,
	"./notice.svg": 91543,
	"./photo.svg": 45249,
	"./qq.svg": 56869,
	"./qqgroup.svg": 3415,
	"./safari.svg": 55943,
	"./shallow.svg": 3957,
	"./shandian.svg": 46307,
	"./sxdianzan.svg": 22667,
	"./tag.svg": 64205,
	"./time.svg": 25537,
	"./topBar.svg": 24838,
	"./topNotice.svg": 64250,
	"./tuijian.svg": 36476,
	"./video.svg": 15766,
	"./weather.svg": 44831,
	"./wechat.svg": 70267,
	"./weibo.svg": 19248,
	"./windowns.svg": 54136,
	"./xkxy.svg": 74377,
	"./yuan.svg": 95276,
	"./yuanchuang.svg": 22202,
	"./zhihu.svg": 26908,
	"./zhuanzai.svg": 91129,
	"./zzlink.svg": 66403
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87886;